const menuItemsData = [
  {
    id: 1,
    title: "american classic",
    category: "lunch",
    price: 15.99,
    img: "./images/item-1.jpeg",
    desc: ` Sweet donut gingerbread apple pie candy croissant topping soufflé. Marshmallow candy canes chocolate cake gummi bears pie. Bear claw cotton candy gingerbread cheesecake chocolate cake bonbon pie sesame snaps`,
  },
  {
    id: 2,
    title: "yummy meal",
    category: "lunch",
    price: 13.99,
    img: "./images/item-2.jpeg",
    desc: `Strip steak do spare ribs ham hock rump nostrud hamburger drumstick ut ad turkey. Turducken in in, dolore short loin sunt pariatur pork andouille. Quis pork chop mollit ad cow drumstick brisket eiusmod irure capicola duis turkey qui `,
  },
  {
    id: 3,
    title: "country delight",
    category: "breakfast",
    price: 6.99,
    img: "./images/item-3.jpeg",
    desc: `Beef laboris aute spare ribs pastrami venison meatball short ribs. Leberkas kielbasa sausage, short ribs biltong labore turducken sirloin proident. Meatloaf t-bone commodo irure doner.`,
  },
  {
    id: 4,
    title: "diner double",
    category: "lunch",
    price: 20.99,
    img: "./images/item-4.jpeg",
    desc: ` chicken capicola landjaeger culpa flank t-bone pork consectetur cupim adipisicing apicola sint burgdoggen eu nisi sed tongue pig fatback aliqua. Laborum boudin buffalo sed reprehenderit `,
  },
  {
    id: 5,
    title: "oreo dream",
    category: "shakes",
    price: 22.99,
    img: "./images/item-5.jpeg",
    desc: `a sweet cold mixture beverage made by blending milk, ice cream, and flavorings or sweeteners such as butterscotch, caramel sauce, chocolate syrup, fruit syrup, including plant milks such as almond milk, coconut milk, or soy milk`,
  },
  {
    id: 6,
    title: "bacon overflow",
    category: "breakfast",
    price: 18.99,
    img: "./images/item-6.jpeg",
    desc: `Spicy jalapeno prosciutto drumstick magna, et fugiat bacon in capicola flank reprehenderit do minim kevin jerky. Ball tip cupidatat burgdoggen enim hamburger. Incididunt ut burgdoggen exercitation turkey nostrud minim commodo`,
  },
  {
    id: 7,
    title: "godzilla milkshake",
    category: "shakes",
    price: 8.99,
    img: "./images/item-7.jpeg",
    desc: `a beverage made by puréeing ingredients in a blender.A smoothie commonly has a liquid base, such as fruit juice or milk, yogurt, ice cream or cottage cheese. Including fruits, vegetables, non-dairy milk, crushed ice, whey powder or nutritional supplements `,
  },
  {
    id: 8,
    title: "buttermilk pancakes",
    category: "breakfast",
    price: 12.99,
    img: "./images/item-8.jpeg",
    desc: `beef ribs laborum chicken in ullamco ham hock jerky. Shoulder adipisicing venison, rump commodo meatloaf doner ea laboris elit. Rump do buffalo in consequat flank. Chicken qui pastrami ground round turducken  `,
  },
  {
    id: 9,
    title: "quarantine buddy",
    category: "shakes",
    price: 16.99,
    img: "./images/item-9.jpeg",
    desc: `a beverage made by puréeing ingredients in a blender. commonly has a liquid base, such as fruit juice or milk, yogurt, ice cream or cottage cheese. including fruits, vegetables, non-dairy milk, crushed ice, powder or nutritional supplements.`,
  },
];
export default menuItemsData;
